/** Breaks a line at its spaces so no line holds more than `chars`, keeping at most `most` lines. */
export function wrapWords(text: string, chars: number, most: number): string[] {
  const lines: string[] = [];
  let line = '';
  for (const word of text.split(' ')) {
    if (line && line.length + 1 + word.length > chars && lines.length < most - 1) {
      lines.push(line);
      line = word;
    } else line = line ? `${line} ${word}` : word;
  }
  if (line) lines.push(line);
  return lines;
}
